module.exports = __webpack_public_path__ + "img/209-indonesia.0306b2ab.svg";